import './personalized-stage.scss';

class PersonalizedStage {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-personalizedstage',
            inputAttr: 'input',
            buttonAttr: 'button',
            headlineAttr: 'headline'
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$personalizedStage = element;
        this.$input = this.$personalizedStage.querySelector(`[${this.settings.initAttr}="${this.settings.inputAttr}"]`);
        this.$button = this.$personalizedStage.querySelector(`[${this.settings.initAttr}="${this.settings.buttonAttr}"]`);
        this.$headline = this.$personalizedStage.querySelector(`[${this.settings.initAttr}="${this.settings.headlineAttr}"]`);

        // Options
        this.sessionStorageId = this.$input?.name || null;
        this.data = this.sessionStorageId !== null ? this.getDataFromSessionStorage(this.sessionStorageId) : null;
        this.welcomeText = null;
        this.initial = true;
    }

    initialize () {
        if (this.$headline && this.$button && this.$input) {
            if (this.data !== null) {
                this.activatePersonalizedStage();
                this.saveDataToSessionStorage(this.$input.name, this.data);
            }

            this.setEvents();

            window.setTimeout(() => {
                this.$personalizedStage.classList.add('personalized-stage--transition');
            }, 500);
        }
    }

    activatePersonalizedStage () {
        let welcomeText = this.$personalizedStage.getAttribute('data-personalizedstage-text');
        welcomeText = welcomeText.replace('%name%', this.data);
        this.$personalizedStage.classList.add('personalized-stage--active');

        if (this.initial) {
            this.$headline.textContent = welcomeText;
        } else {
            window.setTimeout(() => {
                this.addWelcomeText(this.$headline, welcomeText, 0.05);
            }, 500);
        }
    }

    addWelcomeText (element, text, duration) {
        const words = text.split(' ');
        element.innerHTML = '';

        const wordsContainer = document.createElement('div');
        element.style.height = `${element.clientHeight}px`;
        element.appendChild(wordsContainer);

        words.forEach((word, wordIndex) => {
            const wordSpan = document.createElement('span');

            for (const letter of word) {
                const letterSpan = document.createElement('span');
                const italicElement = document.createElement('i');
                italicElement.textContent = letter;
                letterSpan.appendChild(italicElement);
                wordSpan.appendChild(letterSpan);
            }

            wordsContainer.appendChild(wordSpan);

            if (wordIndex === words.length - 1) {
                element.style.height = `${wordsContainer.clientHeight}px`;
            }

            if (wordIndex < words.length - 1) {
                const space = document.createTextNode(' ');
                wordsContainer.appendChild(space);
            }
        });

        const letters = element.querySelectorAll('span > i');
        letters.forEach((node, index) => {
            node.style.animationDelay = `${index * duration}s`;
        });

        window.setTimeout(() => {
            element.style.height = 'auto';
        }, 500);
    }

    saveDataToSessionStorage (key, data) {
        const objectToSave = {
            value: data
        };

        sessionStorage.setItem(key, JSON.stringify(objectToSave));
    }

    getDataFromSessionStorage (key) {
        const storedObject = sessionStorage.getItem(key);

        if (storedObject) {
            const object = JSON.parse(storedObject);
            return object.value;
        }

        return null; // No data found
    }

    setEvents () {
        const handleInput = () => {
            if (this.$input.value !== '') {
                this.initial = false;
                this.data = this.$input.value;
                this.saveDataToSessionStorage(this.$input.name, this.data);
                this.activatePersonalizedStage();
            }
        };

        this.$input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                handleInput();
            }
        });

        this.$button.addEventListener('click', () => {
            handleInput();
        });
    }
}

export { PersonalizedStage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$personalizedStage = $context.querySelectorAll('[data-personalizedstage="root"]');
        for (let i = 0; i < $$personalizedStage.length; i++) {
            const $personalizedStage = $$personalizedStage[i];

            const $personalizedStageAPI = new PersonalizedStage($personalizedStage);
            $personalizedStageAPI.initialize();
        }
    }
});
